import { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { session, user, isAdmin, loading, authError, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const location = useLocation();
  const requestedPath = location.state?.from?.pathname?.startsWith("/admin")
    ? `${location.state.from.pathname}${location.state.from.search || ""}`
    : "/admin";

  useEffect(() => {
    if (!loading && session && user && isAdmin) {
      nav(requestedPath, { replace: true });
    }
  }, [isAdmin, loading, nav, requestedPath, session, user]);

  useEffect(() => {
    if (authError) toast.error(authError);
  }, [authError]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
    } catch (err) {
      toast.error(err?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  if (loading) {
    return <div className="min-h-screen bg-[#070707] flex items-center justify-center text-[#C99A45]">Loading...</div>;
  }
  if (session && user && isAdmin) {
    return <Navigate to={requestedPath} replace />;
  }

  return (
    <div className="min-h-screen bg-[#f5f2ec] text-[#171717] flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
        <div className="text-center mb-8">
          <div className="font-serif-display text-4xl text-[#171717]">Mangalfera Films</div>
          <div className="eyebrow text-[10px] mt-2 text-[#b8914a]">Professional CMS</div>
        </div>
        <div className="space-y-5 border border-[#171717]/10 bg-white rounded-3xl p-8 shadow-[0_20px_70px_rgba(0,0,0,0.08)]">
          <div className="flex items-center gap-2 text-[#b8914a]"><Lock size={14} /><span className="eyebrow text-[11px]">Sign In</span></div>
          <div>
            <label className="eyebrow text-[10px] text-[#6f6a62]">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="admin-input mt-2" data-testid="login-email" />
          </div>
          <div>
            <label className="eyebrow text-[10px] text-[#6f6a62]">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="admin-input mt-2" data-testid="login-password" />
          </div>
          <button type="submit" disabled={busy} className="btn-gold-fill w-full justify-center" data-testid="login-submit">
            {busy ? <><Loader2 size={12} className="animate-spin" /> Signing in</> : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
